import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-invite-friends-text',
  templateUrl: './invite-friends-text.component.html',
  styleUrls: ['./invite-friends-text.component.scss']
})
export class InviteFriendsTextComponent implements OnInit {
  msg:any
  link:any
  copied:boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any,) { }

  ngOnInit(): void {
    this.msg = "Hey, I am using LookzUp for my business. You can control all of your Salon, Beauty Parlour, Spa or Make-up studio with this amazing app. Manage Booking, Billing, Customer, Employee, Expenditure and so many things. Sign-up from the below link:" + "\n\n" + environment.base_lookzup_business_url + '/login?code=' + localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)
  }

  copyInputMessage(inputElement:any){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.copied=true
  }
}
